import script from "./TextAppearBottom.vue?vue&type=script&setup=true&lang=js"
export * from "./TextAppearBottom.vue?vue&type=script&setup=true&lang=js"

import "./TextAppearBottom.vue?vue&type=style&index=0&id=0f13268d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f13268d"]])

export default __exports__